<template>
  <div class="Info-Btn">
    <v-tour name="myTour" :steps="steps" :options="myOptions"></v-tour>
    <button id="search-button" @click="modales">
      <!-- <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.209"
      height="21.205"
      viewBox="0 0 21.209 21.205"
    >
      <g id="icon" transform="translate(1 1)">
        <path
          id="icon-2"
          data-name="icon"
          d="M16.221,16.215A9.5,9.5,0,1,1,19,9.5a9.471,9.471,0,0,1-2.783,6.719L19.5,19.5Z"
          fill="none"
          stroke-linecap="round"
          stroke-width="2"
        />
      </g>
    </svg> -->
      <font-awesome-icon icon="info" />
      <v-dialog v-model="Escritorio" width="800px">
        <Escritorio v-on:close="Escritorio = false"></Escritorio>
      </v-dialog>
      <v-dialog v-model="Proyecto" width="800px">
        <Proyecto v-on:close="Proyecto = false"></Proyecto>
      </v-dialog>
      <v-dialog v-model="Calendar" width="800px">
        <Calendar v-on:close="Calendar = false"></Calendar>
      </v-dialog>
    </button>
  </div>
</template>

<script>
import Escritorio from "../Header/modalHelpEscritorio";
import Proyecto from "../Header/modalHelpProyectos";
import Calendar from "../Header/modalHelpCalendar";
export default {
  data: () => ({
    Proyecto: false,
    Escritorio: false,
    Calendar: false,
    estado: "escritorio",
    FirstTime: [true, true, true],
    steps: [
      {
        target: "#search-button", // We're using document.querySelector() under the hood
        content: ` <strong>To begin click here</strong>`,
        params: {
          placement: "left",
        },
      },
    ],
    myOptions: {
      useKeyboardNavigation: false,
      labels: {
        buttonSkip: "Skip tour",
        buttonPrevious: "Previous",
        buttonNext: "Next",
        buttonStop: "Ok",
      },
    },
  }),
  components: {
    Escritorio,
    Proyecto,
    Calendar,
  },
  watch: {
    $route({ path }) {
      this.$tours["myTour"].stop();
      this.defineTuto(path);
    },
  },
  methods: {
    defineTuto(path) {
      switch (path) {
        case "/":
          this.estado = "proyectos";
          if (this.FirstTime[0]) {
            this.$tours["myTour"].start();
          }
          break;
        case "/project/Design and operation for hydraulic fracturing, Well PE32 – Technical support":
          this.estado = "escritorio";
          if (this.FirstTime[1]) {
            this.$tours["myTour"].start();
          }
          break;
        case "/calendar":
          this.estado = "calendar";
          if (this.FirstTime[2]) {
            this.$tours["myTour"].start();
          }
          break;
      }
    },
    modales() {
      this.$tours["myTour"].stop();
      if (this.estado == "proyectos") {
        this.Proyecto = !this.Proyecto;
        this.FirstTime[0] = false
      } else {
        if (this.estado == "escritorio") {
          this.Escritorio = !this.Escritorio;
          this.FirstTime[1] = false
        }
        if (this.estado == "calendar") {
          this.Calendar = !this.Calendar;
          this.FirstTime[2] = false
        }
      }
    },
  },
  mounted() {
    this.defineTuto(this.$route.path);
    this.$tours["myTour"].start();
  },
};
</script>

<style scoped>
#search-button {
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--second-color);
  border-radius: 100%;
  background: var(--third-color);
  width: 35px;
  height: 35px;
  font-size: 1.375rem;
  border: none;
  outline: none;
}
#search-button:hover {
  color: #fff;
  background: var(--sixth-color);
}
#search-button svg {
  stroke: var(--second-color);
}
#search-button svg:hover {
  stroke: #fff;
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/

@media (max-width: 991px) and (min-width: 768px) {
  #search-button {
    width: 60px;
    height: 60px;
    background: var(--second-color);
    color: var(--third-color);
  }
  #search-button svg {
    stroke: var(--third-color);
    width: 30px;
    height: 30px;
  }
}
@media (max-width: 767px) {
  #search-button {
    width: 35px;
    height: 35px;
    background: var(--second-color);
    color: var(--third-color);
  }
  #search-button svg {
    stroke: var(--third-color);
    width: 25px;
    height: 25px;
  }
}
</style>